export const MARQUEE_ITEMS = [
  "Rescuing & rehoming dogs and cats",
  "100% of every donation goes to the animals",
  "Adoption days — first Saturday of every month, by appointment only",
  "$25 keeps one dog or cat fed for a week",
  "Sponsor a senior dog like Brandy",
  "Volunteer orientations every second Sunday",
  "Item donations welcome — blankets appreciated, food must be Purina One Smart Blend",
  "Pawladays are coming — don't forget us fur babies",
  "Every gift is tax-deductible — 501(c)(3)",
];

export const IMPACT_TIERS = [
  { amount: 25, title: "A Week of Food & Treats", desc: "Keeps one rescue's bowl full for seven days.", icon: "bone", img: "/treats_marobone.webp" },
  { amount: 50, title: "Vaccines & Vet Check", desc: "Core shots plus a full exam for two new arrivals.", icon: "stethoscope", img: "/vet_certification.webp" },
  { amount: 120, title: "Warm Bed & Winter Comfort", desc: "Cozy beds and heating pads for a cold snap on the mountain.", icon: "flame", img: "/warm_bed_dog.webp" },
  { amount: 250, title: "Spay & Neuter Fund", desc: "Helps cover the surgery so every adopted pet goes home fixed and healthy.", icon: "truck", img: "/spay_neuter.webp" },
];

export const THANK_YOU_NAMES = [
  "The Fox Family",
  "Hillside Animal Hospital",
  "Walmart",
  "XMS",
];

export const ADOPTION_STEPS = [
  { n: "01", title: "Apply online", desc: "Tell us about your home, family and what you're looking for. Five minutes, no perfect answers needed." },
  { n: "02", title: "Meet & greet", desc: "Come up the mountain and meet your match face to face — sniffs, wags and all." },
  { n: "03", title: "Home check & adoption day", desc: "A quick virtual home check, then sign the papers and bring your new best friend home." },
];

export const VOLUNTEER_ROLES = ["Remote Fundraising", "Virtual Awareness Campaigns", "Supply Drive Coordinator", "Graphic Design", "Content Creation", "Other — tell us how you'd like to help"];

export const SANCTUARY_STATS = [
  { value: "100%", label: "of every gift to the animals" },
  { value: "501(c)(3)", label: "registered nonprofit" },
  { value: "Dogs & Cats", label: "our whole focus" },
  { value: "MD", label: "mountains of Maryland" },
];

export const ALLOCATION = [
  { pct: 100, label: "Animal care & medical", color: "bg-gold" },
];

export const SHOW_SHOP = false; // flip to true to relaunch the sanctuary shop (Merch section + Shop links reappear)

export const NAV_LINKS = [
  { label: "Our Story", id: "story" },
  { label: "Animals", id: "animals" },
  { label: "Adopt", id: "adopt" },
  { label: "Volunteer", id: "volunteer" },
  ...(SHOW_SHOP ? [{ label: "Shop", id: "merch" }] : []),
  { label: "Tributes", href: "/tributes" },
];
